(() => {
  const dialog = document.getElementById('HdNewsletterPopup');
  const form = document.getElementById('HdNewsletterForm');
  if (!dialog || !form || typeof dialog.showModal !== 'function') return;

  const nudge = document.getElementById('HdNewsletterNudge');
  const mobileInvitation = window.matchMedia('(max-width: 749px), (max-width: 1023px) and (max-height: 550px) and (pointer: coarse)');

  const storageKey = 'her-dad-newsletter-dismiss-until';
  const subscribedKey = 'her-dad-newsletter-signed-up';
  const pendingKey = 'her-dad-newsletter-pending';
  const week = 7 * 24 * 60 * 60 * 1000;
  const result = dialog.querySelector('[data-hd-newsletter-result]')?.dataset.hdNewsletterResult;
  const dismiss = dialog.querySelector('[data-hd-newsletter-dismiss]');
  if (result === 'success' && dismiss) dismiss.textContent = dismiss.dataset.successLabel;
  let timer;
  let engagedAt = 0;
  let lastInteraction = 0;
  let submitted = false;
  let hasShown = false;
  let returnFocus;
  let nudgeReturnFocus;

  const readStorage = (kind, key) => {
    try {
      const storage = kind === 'session' ? window.sessionStorage : window.localStorage;
      return Number(storage.getItem(key)) || 0;
    } catch {
      return 0;
    }
  };

  const writeStorage = (kind, key, value) => {
    try {
      const storage = kind === 'session' ? window.sessionStorage : window.localStorage;
      storage.setItem(key, String(value));
    } catch {}
  };

  const clearPending = () => {
    try {
      sessionStorage.removeItem(pendingKey);
    } catch {}
  };

  const hideNudge = () => {
    if (nudge) nudge.hidden = true;
  };

  const stopAutomatic = () => {
    submitted = true;
    clearTimeout(timer);
    hideNudge();
  };

  const canRestoreFocus = (element) => {
    return element instanceof HTMLElement && element.isConnected && element.getClientRects().length > 0 &&
      getComputedStyle(element).visibility !== 'hidden';
  };

  const blocked = (manual = false) => {
    if (document.hidden || (!manual && submitted)) return true;
    if (/\/(?:checkouts?|challenge)(?:\/|$)/i.test(location.pathname)) return true;
    if (!manual && /\/cart(?:\/|$)/i.test(location.pathname)) return true;
    if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return true;
    return [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')].some((element) => {
      return element !== dialog && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    });
  };

  const open = (manual = false) => {
    if (dialog.open || blocked(manual)) return false;
    if (!manual && (hasShown || readStorage('local', storageKey) > Date.now() || readStorage('local', subscribedKey))) return false;
    clearTimeout(timer);
    if (!manual && mobileInvitation.matches) {
      if (!nudge) return false;
      nudgeReturnFocus = document.activeElement;
      nudge.hidden = false;
      hasShown = true;
      return true;
    }
    returnFocus = document.activeElement;
    dialog.showModal();
    hasShown = true;
    const focusTarget = dialog.querySelector('[role="alert"], [role="status"], #HdNewsletterHeading');
    focusTarget?.focus({ preventScroll: true });
    return true;
  };

  const tryAutomatic = () => {
    if (hasShown || submitted || Date.now() - engagedAt > 120000) return;
    if (Date.now() - lastInteraction < 1500 || !open()) {
      timer = setTimeout(tryAutomatic, 2000);
    }
  };

  const engage = () => {
    if (engagedAt || dialog.dataset.designMode === 'true') return;
    if (readStorage('local', storageKey) > Date.now() || readStorage('local', subscribedKey)) return;
    engagedAt = Date.now();
    timer = setTimeout(tryAutomatic, 12000);
  };

  dialog.addEventListener('close', () => {
    clearTimeout(timer);
    hideNudge();
    writeStorage('local', storageKey, Date.now() + week);
    if (dialog.dataset.returnCart === 'true') {
      delete dialog.dataset.returnCart;
      document.getElementById('cart-drawer')?.open?.();
      return;
    }
    const focusTarget = [returnFocus, nudgeReturnFocus].find(canRestoreFocus);
    focusTarget?.focus({ preventScroll: true });
  });

  nudge?.addEventListener('click', (event) => {
    if (!event.target.closest('[data-hd-newsletter-nudge-close]')) return;
    clearTimeout(timer);
    hideNudge();
    writeStorage('local', storageKey, Date.now() + week);
  });

  mobileInvitation.addEventListener('change', () => {
    if (!mobileInvitation.matches) hideNudge();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) hideNudge();
  });

  dialog.addEventListener('click', (event) => {
    if (event.target.closest('[data-hd-newsletter-close]')) {
      dialog.close();
      return;
    }
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });

  document.addEventListener('click', (event) => {
    if (event.composedPath().some((node) => node instanceof Element && node.matches('a[href*="/checkout"], [name="checkout"], .shopify-payment-button__button--unbranded, shopify-buy-it-now-button, [data-hd-checkout-fire]'))) {
      stopAutomatic();
    }
    const trigger = event.target.closest('[data-hd-newsletter-open]');
    if (!trigger) return;
    event.preventDefault();
    const drawer = trigger.closest('#cart-drawer');
    if (drawer?.isOpen && typeof drawer.close === 'function') {
      Promise.resolve(drawer.close()).then(() => {
        if (open(true)) dialog.dataset.returnCart = 'true';
      });
      return;
    }
    open(true);
  });

  document.addEventListener('submit', stopAutomatic, true);

  form.addEventListener('submit', () => {
    writeStorage('session', pendingKey, Date.now());
    writeStorage('local', storageKey, Date.now() + week);
    const button = form.querySelector('button[type="submit"]');
    if (button) {
      button.disabled = true;
      button.textContent = button.dataset.submittingLabel || button.textContent;
    }
  });

  document.addEventListener('pointerdown', (event) => {
    lastInteraction = Date.now();
    if (!event.target.closest('form, input, textarea, select')) engage();
  }, { passive: true });

  document.addEventListener('keydown', (event) => {
    lastInteraction = Date.now();
    if (['PageDown', 'ArrowDown', 'End', ' '].includes(event.key) && !event.target.closest('form, input, textarea, select')) engage();
  });

  window.addEventListener('scroll', () => {
    if (window.scrollY > Math.min(160, window.innerHeight * 0.2)) engage();
  }, { passive: true });

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    submitted = false;
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = false;
  });

  const pendingAt = readStorage('session', pendingKey);
  if (pendingAt && Date.now() - pendingAt < 20 * 60 * 1000 && ['success', 'error'].includes(result)) {
    clearPending();
    if (result === 'success') writeStorage('local', subscribedKey, Date.now());
    const resultWaitStarted = Date.now();
    const showResult = () => {
      if (submitted || Date.now() - resultWaitStarted > 120000) return;
      if (!open(true)) timer = setTimeout(showResult, 2000);
    };
    showResult();
  } else if (pendingAt && Date.now() - pendingAt >= 20 * 60 * 1000) {
    clearPending();
  }
})();

